<template>
  <entity-edit-form
    :title="title"
    :data-service="dataService"
    :create-entity="createEntity"
    :fields="fields"
    list-route-name="sources"
    :item-id="entityId"
  >
    <template #field.image="{ item }">
      <upload-image
        v-model="item.image"
        label="Загрузить файл"
        color="primary"
        dialog-width="500"
        max-img-height="500"
        max-img-width="500"
      >
        <v-icon left v-text="`mdi-tray-arrow-up`" />
        Загрузить фото
      </upload-image>
    </template>
  </entity-edit-form>
</template>

<script>
  import EntityEditForm from '@/components/ui/crud/EntityEditForm'
  import { VCheckbox, VTextField } from 'vuetify/lib'
  import { max, min, upperCase } from '@/util/rules'
  import UploadImage from '@/components/UploadImage.vue'
  import SourceDataService from '@/services/api/SourceDataService'

  export default {
    components: { UploadImage, EntityEditForm },
    data () {
      return {
        title: 'Новый источник',
        dataService: SourceDataService,
        fields: [
          {
            key: 'name',
            label: 'Название',
            component: VTextField,
            defaultValue: null,
            rules: ['required'],
          },
          {
            key: 'abbreviation',
            label: 'Аббревиатура (2 или 3 большие буквы)',
            component: VTextField,
            rules: [min(2), max(3), upperCase()],
            defaultValue: null,
          },
          {
            key: 'requiredForAllFilials',
            label: 'Обязателен для всех филиалов',
            component: VCheckbox,
            defaultValue: false,
          },
          {
            key: 'image',
            label: 'Логотип',
          },
        ],
      }
    },
    computed: {
      entityId () {
        return this.$route.params.id
      },
      createEntity () {
        return !this.entityId
      },
    },
    created () {
      if (this.entityId) {
        this.title = 'Редактирование источника'
      }
    },
  }
</script>
